export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./trans-bets.vue?vue&type=template&id=42b02bb1&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/trans-bets.vue?vue&type=template&id=42b02bb1&scoped=true
// module id = GGEs
// module chunks = 0